import { useLocation, NavLink, Redirect } from "react-router-dom";

const PaymentSuccess = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const orderId = query.get("id");
    const ref     = query.get("ref");
    const amount  = query.get("amount");
    const trnDate  = query.get("date");
    const invoiceNo  = query.get("invoiceno");
    // const refType  = query.get("reftype");

    const formatAmount = (amt) => {
        if (!amt) return 'N/A';
        return `\u20B9${parseFloat(amt).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;
    };

    const formatDate = (d) => {   
        if (!d) return moment().format('DD MMM YYYY, hh:mm:ss A');    
        return moment(d, 'DD-MM-YYYY HH:mm:ss').format('DD MMM YYYY, hh:mm:ss A');
    };

    if (!orderId) return <Redirect to="/login" />;

    const copyRef = () => {
        if (ref && navigator.clipboard) {
            navigator.clipboard.writeText(ref);
        }
    };

    return (
        <div className="container margin-t50">
            <div className="row">
                <div className="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">
                    <div className="panel panel-default">
                        <div className="panel-body text-center">
                            <i
                                className="fa fa-check-circle"
                                style={{ fontSize: '5rem', color: '#498d49', marginBottom: '1rem', display: 'block' }}
                            ></i>
                            <h3 style={{ color: '#3b77af', marginTop: 0, marginBottom: '0.5rem' }}>Payment Successful!</h3>
                            <p className="text-muted">Your payment has been processed successfully.</p>

                            <div className="well well-sm" style={{ marginTop: '1.5rem', textAlign: 'left' }}>
                                <table className="table table-condensed" style={{ marginBottom: 0 }}>
                                    <tbody>
                                        {orderId && (
                                            <tr>
                                                <td><strong>Order ID</strong></td>
                                                <td>{orderId}</td>
                                            </tr>
                                        )}
                                        {ref && (
                                            <tr>
                                                <td><strong>Tracking ID</strong></td>
                                                <td>
                                                    {ref}
                                                    <button
                                                        onClick={copyRef}
                                                        className="btn btn-xs btn-default"
                                                        style={{ marginLeft: '8px' }}
                                                        title="Copy reference number"
                                                    >
                                                        <i className="fa fa-copy"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        )}
                                        {amount && (
                                            <tr>
                                                <td><strong>Amount Paid</strong></td>
                                                <td style={{ color: '#3a70c0', fontWeight: 'bold' }}>{formatAmount(amount)}</td>
                                            </tr>
                                        )}

                                        {trnDate && (
                                             <tr>
                                                <td><strong>Transaction Date &amp; Time</strong></td>
                                                <td>{formatDate(trnDate)}</td>
                                            </tr>
                                        )}
                                       
                                    </tbody>
                                </table>
                            </div>

                            <div style={{ marginTop: '1.5rem' }}>
                                {invoiceNo && (
                                    <NavLink to={`/invoice?id=${invoiceNo}`} className="btn btn-success btn-block" style={{ marginBottom: '0.5rem' }}>
                                        <i className="fa fa-calendar"></i> View Invoice
                                    </NavLink>
                                )}
                                <NavLink to="/login" className="btn btn-default btn-block">
                                    <i className="fa fa-home"></i> Back to Home
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;
